var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop",
              attrs: {
                title: _vm.$t("booking.bookingSplit.spliteCombinType1"),
                isShowFollow: false,
                width: "70%",
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: { position: "relative" },
                    attrs: { gutter: 1 },
                  },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("home.copyNumber") + "：") +
                            _vm._s(_vm.dataInfo.length)
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "table-container-new-back",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "tableFormRef",
                          staticStyle: { display: "flex" },
                          attrs: { rules: _vm.tableRules, model: _vm.formData },
                        },
                        [
                          _vm.formData.dataInfo.length > 0
                            ? _c(
                                "el-table",
                                {
                                  ref: "multipleTable",
                                  staticStyle: { width: "83%" },
                                  attrs: { data: _vm.formData.dataInfo },
                                },
                                [
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: { prop: "flag", width: "100px" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticStyle: {
                                                      "margin-bottom": "15px",
                                                    },
                                                    attrs: {
                                                      prop:
                                                        "formData.dataInfo." +
                                                        scope.$index +
                                                        ".flag",
                                                      rules:
                                                        _vm.tableRules.flag,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-checkbox",
                                                      {
                                                        attrs: {
                                                          disabled: _vm.mainId
                                                            ? true
                                                            : false,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleChange(
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: scope.row.flag,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "flag",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.flag",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "home.order"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1918799728
                                      ),
                                    },
                                    [
                                      _c("template", { slot: "header" }, [
                                        _c(
                                          "span",
                                          { staticClass: "required-marker" },
                                          [_vm._v(" *")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "required-marker" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("home.selectOrder"))
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: { prop: "bkNo" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticStyle: {
                                                      "margin-bottom": "15px",
                                                    },
                                                    attrs: {
                                                      prop:
                                                        "formData.dataInfo." +
                                                        scope.$index +
                                                        ".bkNo",
                                                      rules:
                                                        _vm.tableRules.bkNo,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          "popper-class":
                                                            "custom-tooltip-popper",
                                                          effect: "light",
                                                          content:
                                                            scope.row.bkNo,
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            disabled: true,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.bkNo,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "bkNo",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.bkNo",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1320749500
                                      ),
                                    },
                                    [
                                      _c("template", { slot: "header" }, [
                                        _c(
                                          "span",
                                          { staticClass: "required-marker" },
                                          [_vm._v(" *")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "required-marker" },
                                          [_vm._v(_vm._s(_vm.$t("home.bkNo")))]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: { prop: "blNo" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticStyle: {
                                                      "margin-bottom": "15px",
                                                    },
                                                    attrs: {
                                                      prop:
                                                        "formData.dataInfo." +
                                                        scope.$index +
                                                        ".blNo",
                                                      rules:
                                                        _vm.tableRules.blNo,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          "popper-class":
                                                            "custom-tooltip-popper",
                                                          effect: "light",
                                                          content:
                                                            scope.row.blNo,
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            disabled: true,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.blNo,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "blNo",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.blNo",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        593793692
                                      ),
                                    },
                                    [
                                      _c("template", { slot: "header" }, [
                                        _c(
                                          "span",
                                          { staticClass: "required-marker" },
                                          [_vm._v(" *")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "required-marker" },
                                          [_vm._v(_vm._s(_vm.$t("home.blNo")))]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "vesselCode",
                                      label: _vm.$t(
                                        "booking.bookingSplit.vesselName"
                                      ),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "15px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        "popper-class":
                                                          "custom-tooltip-popper",
                                                        effect: "light",
                                                        content:
                                                          scope.row.vesselCode,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .vesselCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "vesselCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.vesselCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4230409573
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "voyageNo",
                                      label: _vm.$t("home.voyageNo"),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "15px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        "popper-class":
                                                          "custom-tooltip-popper",
                                                        effect: "light",
                                                        content:
                                                          scope.row.voyageNo,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.voyageNo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "voyageNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.voyageNo",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4068783653
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "pol",
                                      label: _vm.$t("home.pol"),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "15px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        "popper-class":
                                                          "custom-tooltip-popper",
                                                        effect: "light",
                                                        content: scope.row.pol,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value: scope.row.pol,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "pol",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.pol",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      579351685
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "etd", label: "ETD" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "15px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        "popper-class":
                                                          "custom-tooltip-popper",
                                                        effect: "light",
                                                        content: scope.row.etd,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: true,
                                                        },
                                                        model: {
                                                          value: scope.row.etd,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "etd",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.etd",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4225807557
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      margin: "20px 0 0px 0",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-info-primary",
                        staticStyle: {
                          "margin-bottom": "20px",
                          "min-width": "90px",
                          height: "30px",
                        },
                        on: { click: _vm.handleButtonClose },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("home.buttonClose")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-plain-primary",
                        staticStyle: {
                          "margin-bottom": "20px",
                          "min-width": "90px",
                          height: "30px",
                        },
                        attrs: {
                          disabled: _vm.mainId ? false : true,
                          type: "primary",
                        },
                        on: { click: _vm.handleCancent },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("home.closeCombin")) + "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-primary",
                        staticStyle: {
                          "margin-bottom": "20px",
                          "min-width": "90px",
                          height: "30px",
                        },
                        attrs: {
                          disabled: _vm.mainId ? true : false,
                          type: "primary",
                        },
                        on: { click: _vm.handleApply },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("home.sureCombin")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }